import { render, staticRenderFns } from "./PageActions.vue?vue&type=template&id=17c729fc&"
import script from "./PageActions.vue?vue&type=script&lang=js&"
export * from "./PageActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports